// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  worldId: __t.u64().primaryKey().name("world_id"),
  timeMode: __t.string().name("time_mode"),
  fixedTimeOfDay: __t.f32().name("fixed_time_of_day"),
  weatherMode: __t.string().name("weather_mode"),
  fogMul: __t.f32().name("fog_mul"),
  fogColorHex: __t.string().name("fog_color_hex"),
  sunMul: __t.f32().name("sun_mul"),
  ambientMul: __t.f32().name("ambient_mul"),
  sunTintHex: __t.string().name("sun_tint_hex"),
  ambienceKey: __t.string().name("ambience_key"),
  ambienceGain: __t.f32().name("ambience_gain"),
  updatedBy: __t.identity().name("updated_by"),
  updatedAt: __t.timestamp().name("updated_at"),
});
